import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'app-payer-config-edit-renderer',
    templateUrl: './payer-config-edit-renderer.component.html',
    styleUrls: ['./payer-config-edit-renderer.component.scss'],
    imports: [MatIcon, MatTooltip]
})
export class PayerConfigEditRendererComponent implements ICellRendererAngularComp {

  params: ICellRendererParams<any, any>;
  // Optional tooltip/aria label from cellRendererParams.tooltip, e.g. 'Edit Service Year'.
  tooltip = '';

  constructor() {
    //TODO
  }

  agInit(params: ICellRendererParams<any, any> & { tooltip?: string }): void {
    this.params = params;
    this.tooltip = params.tooltip ?? '';
  }
  
  refresh(params: ICellRendererParams<any, any>): boolean {
    return false;
  }

  onIconClick(event) {
    event.stopImmediatePropagation();
    this.params.context.componentParent.onEditPayerClick(this.params.data);
  }

}